<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="客户编号" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="客户编号"></el-input>
      </el-form-item>
          <el-form-item label="用户姓名" prop="name">
          <el-input v-model="dataForm.name" placeholder="用户姓名"></el-input>
      </el-form-item>
          <el-form-item label="手机号" prop="mobile">
          <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
          <el-form-item label="机构ID" prop="operationId">
          <el-input v-model="dataForm.operationId" placeholder="机构ID"></el-input>
      </el-form-item>
          <el-form-item label="渠道id" prop="channelId">
          <el-input v-model="dataForm.channelId" placeholder="渠道id"></el-input>
      </el-form-item>
          <el-form-item label="所属公司" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="所属公司"></el-input>
      </el-form-item>
          <el-form-item label="门店id" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="门店id"></el-input>
      </el-form-item>
          <el-form-item label="来源落地页" prop="pageId">
          <el-input v-model="dataForm.pageId" placeholder="来源落地页"></el-input>
      </el-form-item>
          <el-form-item label="0未回访1有效2无效" prop="type">
          <el-input v-model="dataForm.type" placeholder="0未回访1有效2无效"></el-input>
      </el-form-item>
          <el-form-item label="访问IP" prop="ip">
          <el-input v-model="dataForm.ip" placeholder="访问IP"></el-input>
      </el-form-item>
          <el-form-item label="城市" prop="city">
          <el-input v-model="dataForm.city" placeholder="城市"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="访问URL" prop="url">
          <el-input v-model="dataForm.url" placeholder="访问URL"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createdAt">
          <el-input v-model="dataForm.createdAt" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updatedAt">
          <el-input v-model="dataForm.updatedAt" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deletedAt">
          <el-input v-model="dataForm.deletedAt" placeholder="删除时间"></el-input>
      </el-form-item>
          <el-form-item label="是否推送" prop="isPush">
          <el-input v-model="dataForm.isPush" placeholder="是否推送"></el-input>
      </el-form-item>
          <el-form-item label="推送内容" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送内容"></el-input>
      </el-form-item>
          <el-form-item label="推送日期" prop="pushDate">
          <el-input v-model="dataForm.pushDate" placeholder="推送日期"></el-input>
      </el-form-item>
          <el-form-item label="身份证" prop="cardno">
          <el-input v-model="dataForm.cardno" placeholder="身份证"></el-input>
      </el-form-item>
          <el-form-item label="婚姻状况" prop="isMarried">
          <el-input v-model="dataForm.isMarried" placeholder="婚姻状况"></el-input>
      </el-form-item>
          <el-form-item label="教育程度" prop="education">
          <el-input v-model="dataForm.education" placeholder="教育程度"></el-input>
      </el-form-item>
          <el-form-item label="职业" prop="professional">
          <el-input v-model="dataForm.professional" placeholder="职业"></el-input>
      </el-form-item>
          <el-form-item label="就业时长" prop="employmentTime">
          <el-input v-model="dataForm.employmentTime" placeholder="就业时长"></el-input>
      </el-form-item>
          <el-form-item label="月收入（元）" prop="monthlyIncome">
          <el-input v-model="dataForm.monthlyIncome" placeholder="月收入（元）"></el-input>
      </el-form-item>
          <el-form-item label="工资发放形式" prop="payrollType">
          <el-input v-model="dataForm.payrollType" placeholder="工资发放形式"></el-input>
      </el-form-item>
          <el-form-item label="申请金额" prop="money">
          <el-input v-model="dataForm.money" placeholder="申请金额"></el-input>
      </el-form-item>
          <el-form-item label="贷款用途" prop="usefor">
          <el-input v-model="dataForm.usefor" placeholder="贷款用途"></el-input>
      </el-form-item>
          <el-form-item label="贷款期限" prop="loanLongTime">
          <el-input v-model="dataForm.loanLongTime" placeholder="贷款期限"></el-input>
      </el-form-item>
          <el-form-item label="信用情况" prop="creditSituation">
          <el-input v-model="dataForm.creditSituation" placeholder="信用情况"></el-input>
      </el-form-item>
          <el-form-item label="信用卡" prop="isCredit">
          <el-input v-model="dataForm.isCredit" placeholder="信用卡"></el-input>
      </el-form-item>
          <el-form-item label="社保" prop="shebao">
          <el-input v-model="dataForm.shebao" placeholder="社保"></el-input>
      </el-form-item>
          <el-form-item label="公积金" prop="gongjijin">
          <el-input v-model="dataForm.gongjijin" placeholder="公积金"></el-input>
      </el-form-item>
          <el-form-item label="房产" prop="house">
          <el-input v-model="dataForm.house" placeholder="房产"></el-input>
      </el-form-item>
          <el-form-item label="车产" prop="car">
          <el-input v-model="dataForm.car" placeholder="车产"></el-input>
      </el-form-item>
          <el-form-item label="商业保险" prop="baodanIs">
          <el-input v-model="dataForm.baodanIs" placeholder="商业保险"></el-input>
      </el-form-item>
          <el-form-item label="芝麻信用" prop="zmscore">
          <el-input v-model="dataForm.zmscore" placeholder="芝麻信用"></el-input>
      </el-form-item>
          <el-form-item label="微粒贷" prop="weili">
          <el-input v-model="dataForm.weili" placeholder="微粒贷"></el-input>
      </el-form-item>
          <el-form-item label="企业主" prop="businesslicense">
          <el-input v-model="dataForm.businesslicense" placeholder="企业主"></el-input>
      </el-form-item>
          <el-form-item label="备注1" prop="remark1">
          <el-input v-model="dataForm.remark1" placeholder="备注1"></el-input>
      </el-form-item>
          <el-form-item label="备注2" prop="remark2">
          <el-input v-model="dataForm.remark2" placeholder="备注2"></el-input>
      </el-form-item>
          <el-form-item label="年齢" prop="age">
          <el-input v-model="dataForm.age" placeholder="年齢"></el-input>
      </el-form-item>
          <el-form-item label="房屋类型" prop="houseType">
          <el-input v-model="dataForm.houseType" placeholder="房屋类型"></el-input>
      </el-form-item>
          <el-form-item label="" prop="housePrice">
          <el-input v-model="dataForm.housePrice" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="房屋面积" prop="houseSize">
          <el-input v-model="dataForm.houseSize" placeholder="房屋面积"></el-input>
      </el-form-item>
          <el-form-item label="房屋年限" prop="houseLife">
          <el-input v-model="dataForm.houseLife" placeholder="房屋年限"></el-input>
      </el-form-item>
          <el-form-item label="" prop="carPrice">
          <el-input v-model="dataForm.carPrice" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="新车|二手车" prop="carType">
          <el-input v-model="dataForm.carType" placeholder="新车|二手车"></el-input>
      </el-form-item>
          <el-form-item label="车型" prop="carModel">
          <el-input v-model="dataForm.carModel" placeholder="车型"></el-input>
      </el-form-item>
          <el-form-item label="车辆年限" prop="carLife">
          <el-input v-model="dataForm.carLife" placeholder="车辆年限"></el-input>
      </el-form-item>
          <el-form-item label="" prop="transId">
          <el-input v-model="dataForm.transId" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="status">
          <el-input v-model="dataForm.status" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="贷款类型" prop="loanType">
          <el-input v-model="dataForm.loanType" placeholder="贷款类型"></el-input>
      </el-form-item>
          <el-form-item label="广告计划" prop="ads">
          <el-input v-model="dataForm.ads" placeholder="广告计划"></el-input>
      </el-form-item>
          <el-form-item label="创意" prop="creativeid">
          <el-input v-model="dataForm.creativeid" placeholder="创意"></el-input>
      </el-form-item>
          <el-form-item label="返回信息" prop="returnMsg">
          <el-input v-model="dataForm.returnMsg" placeholder="返回信息"></el-input>
      </el-form-item>
          <el-form-item label="" prop="productId">
          <el-input v-model="dataForm.productId" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="sex">
          <el-input v-model="dataForm.sex" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="channelName">
          <el-input v-model="dataForm.channelName" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="账户id" prop="ucid">
          <el-input v-model="dataForm.ucid" placeholder="账户id"></el-input>
      </el-form-item>
          <el-form-item label="线索id" prop="clueId">
          <el-input v-model="dataForm.clueId" placeholder="线索id"></el-input>
      </el-form-item>
              <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        customerId: '',
        name: '',
        mobile: '',
        operationId: '',
        channelId: '',
        companyId: '',
        deptId: '',
        pageId: '',
        type: '',
        ip: '',
        city: '',
        remark: '',
        url: '',
        createdAt: '',
        updatedAt: '',
        deletedAt: '',
        isPush: '',
        pushMsg: '',
        pushDate: '',
        cardno: '',
        isMarried: '',
        education: '',
        professional: '',
        employmentTime: '',
        monthlyIncome: '',
        payrollType: '',
        money: '',
        usefor: '',
        loanLongTime: '',
        creditSituation: '',
        isCredit: '',
        shebao: '',
        gongjijin: '',
        house: '',
        car: '',
        baodanIs: '',
        zmscore: '',
        weili: '',
        businesslicense: '',
        remark1: '',
        remark2: '',
        age: '',
        houseType: '',
        housePrice: '',
        houseSize: '',
        houseLife: '',
        carPrice: '',
        carType: '',
        carModel: '',
        carLife: '',
        transId: '',
        status: '',
        loanType: '',
        ads: '',
        creativeid: '',
        returnMsg: '',
        productId: '',
        sex: '',
        channelName: '',
        ucid: '',
        clueId: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        customerId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        operationId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pageId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ip: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdAt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedAt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deletedAt: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cardno: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isMarried: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        education: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        professional: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        employmentTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        monthlyIncome: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        payrollType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        usefor: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanLongTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creditSituation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isCredit: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        shebao: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        gongjijin: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        house: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        car: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        baodanIs: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        zmscore: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        weili: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businesslicense: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark1: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark2: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        age: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        houseType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        housePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        houseSize: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        houseLife: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        carPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        carType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        carModel: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        carLife: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        transId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loanType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ads: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creativeid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sex: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ucid: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        clueId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/bcustomers/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/bcustomers/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
